import { render, staticRenderFns } from "./DetailSettings.vue?vue&type=template&id=50958c9a&scoped=true&"
import script from "./DetailSettings.vue?vue&type=script&lang=js&"
export * from "./DetailSettings.vue?vue&type=script&lang=js&"
import style0 from "./DetailSettings.vue?vue&type=style&index=0&id=50958c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50958c9a",
  null
  
)

export default component.exports